let dappToken;
let dappName;
 
let windowWallet;
if (typeof window !== 'undefined') {
  windowWallet = window;
}
 
export { dappToken, dappName, windowWallet };